import PhotoGrid from '@components/photo-grid/photo-grid.component'
import { withTransaction } from '@elastic/apm-rum-react'
import { Callout, Input, PurposeMediaKit } from '@hub/shared'
import { useCallback, useEffect, useState } from 'react'
import { useTranslation } from 'react-i18next'
import './about.page.scoped.scss'
interface Props {
  purpose?: PurposeMediaKit
  idProfile?: string
  loadingSubmit?: boolean
  onChange?: (event: any) => any
  getValidation?: (valid: boolean) => void
}

const AboutPageComponent = ({ onChange, getValidation, purpose, idProfile, loadingSubmit }: Props) => {
  const [t] = useTranslation('aboutMediaKitPage')
  const [valid, setValid] = useState({
    text: !!purpose?.text,
    images: purpose?.images?.length === 6,
  })

  const handleOnChange = useCallback(
    (purpose: PurposeMediaKit) => {
      if (onChange && typeof onChange === 'function') {
        onChange(purpose)
      }
    },
    [onChange]
  )

  const handleValidate = (object: any) => {
    setValid({ ...valid, ...object })
    const fieldsValid = Object.values(valid).every((value) => value === true)
    if (getValidation && typeof getValidation === 'function') {
      getValidation(fieldsValid)
    }
  }

  useEffect(() => {
    if (getValidation && typeof getValidation === 'function') {
      getValidation(!!purpose?.text?.length && purpose?.images?.length === 6)
    }
  }, [purpose, getValidation])

  return (
    <div className="about-media-kit-page">
      <h5>{t('textAreaTitle')}</h5>
      <Input
        label={t('textAreaLabel')}
        placeholder={t('textAreaPlaceholder')}
        value={purpose?.text || ''}
        readOnly={loadingSubmit}
        type="textarea"
        className="about-media-kit-textarea"
        name="about-media-kit-textarea"
        id="about-media-kit-textarea"
        maxLength={650}
        onChange={(newText) => handleOnChange({ ...purpose!, text: newText })}
        onValidate={(valid: boolean) => handleValidate({ text: valid })}
        required
      />

      <div className="about-tip-media-kit-page-middle">
        <Callout
          colorIcon="var(--text_color)"
          className="box-shadow mb-6"
          backgroundColor="var(--background_secondary)"
          title={t('tip.title')}
          iconFontSize="34px"
          icon={'fa-solid fa-lightbulb-on'}
        >
          {t('tip.text')}
        </Callout>
      </div>

      <div className="about-media-kit-page-photo-grid">
        <h5 className="mx-0">{t('photoGridTitle')}</h5>
        <label className="mb-3">{t('photoGridText')}</label>
        <PhotoGrid
          name="media-kit-about"
          size={6}
          featuredPhoto={4}
          photos={purpose?.images || []}
          idProfile={idProfile!}
          onChange={(newPhotos) => handleOnChange({ ...purpose!, images: newPhotos })}
          onValidate={(valid) => handleValidate({ images: valid })}
        />
      </div>
    </div>
  )
}

export default withTransaction('AboutPageComponent', 'component')(AboutPageComponent)
